export const YOUTUBE_VIDEOS = {
  HOME_TRAILER: {
    id: "RQWHgjbt1Yg",
    title: "Introducing IDH’s Living Income Toolkit",
  },
  IDC_PRECURSOR: {
    id: "DOG1yh-tdZY",
    title:
      "Introducing IDH’s Income Driver Calculator & Income Measurement Guidance Tool",
  },
  IDC_USER_MANUAL_1_3: {
    id: "zPb2K73GToo",
    title: "Income Driver Calculator User Manual: Steps 1-3",
  },
  IDC_USER_MANUAL_4_5: {
    id: "eWEc1jzCG10",
    title: "Income Driver Calculator User Manual: Steps 4-5",
  },
  PROCUREMENT_PRINCIPLES: {
    id: "kYJtV7c_Vd0",
    title: "Introducing Five Core Principles towards Sustainable Procurement",
  },
};
